import { IGame } from "@grassrootly/api/entities";
import { UpdateGamePayload } from "@grassrootly/api/gateways";
import withErrorCheck from "../CheckError";
import server from "../Server";

export const UpdateGame = async (payload: UpdateGamePayload): Promise<Omit<IGame, "group" | "attendees">> => {
  // Update the game
  // Build update object with only the fields that should be updated
  const updateData: any = {
    location: payload.location,
    notes: payload.notes,
    datetime: payload.datetime?.toISOString(),
    season_id: payload.seasonId,
  };

  // Only update team names if they are provided
  if (payload.hostTeamName !== undefined) {
    updateData.host_team_name = payload.hostTeamName;
  }
  if (payload.visitorTeamName !== undefined) {
    updateData.visitor_team_name = payload.visitorTeamName;
  }

  await withErrorCheck(
    await server
      .from("Games")
      .update(updateData)
      .eq("id", payload.gameId)
  );

  // Return the updated game data from game_overview view
  return withErrorCheck(
    await server
      .from("game_overview")
      .select("*")
      .eq("game_id", payload.gameId)
  )[0];
};
